import clsx from "clsx"

export interface BannerCarouselIndicatorProps {
  isActive: boolean
  label: string
  onClick: () => void
}

export default function BannerCarouselIndicator({ isActive, label, onClick }: BannerCarouselIndicatorProps) {
  return (
    <button
      type="button"
      // The dot has no text or icon, so aria-label is its only accessible name.
      aria-label={label}
      aria-current={isActive}
      className={clsx(
        'block mr-2 w-16 h-1.5 origin-left border-none cursor-pointer rounded-full transition-transform duration-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-background',
        isActive ? 'scale-x-100 bg-primary ' : 'scale-x-[0.4375] bg-foreground/40',
      )}
      onClick={isActive ? undefined : onClick}
    />
  )
}
